import React from 'react';
import { steps } from '../data/site';
export function Process() {
  return <section id="process" className="w-full bg-[#0B2A6B]" data-id="element-101" data-mp="1udljfcw90bs6">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 md:py-28" data-id="element-102" data-mp="1uc26nw9swiv5">
        <div className="max-w-xl" data-id="element-103" data-mp="1yeyo3jnlu8xi">
          <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-sky-300" data-id="element-104" data-mp="1yg013to6l5hv">
            How it works
          </p>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-white sm:text-4xl" data-id="element-105" data-mp="16o12t0nkhqm2">
            Simple from first call to last pane
          </h2>
        </div>

        <ol className="mt-14 grid gap-10 md:grid-cols-3" data-id="element-106" data-mp="1apvztsygthu1">
          {steps.map((step, index) => <li key={step.title} className="border-t border-white/20 pt-6" data-id="element-107" data-mp="1fne8di8klv1i" data-mpi={index}>
              <span className="font-mono text-xs text-sky-300" data-id="element-108" data-mp="1kg7g8ezc5jht">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 text-lg font-medium text-white" data-id="element-109" data-mp="my7c6pwl9hjf">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-sky-100/70" data-id="element-110" data-mp="rx1uzruk363j">{step.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}